import React from 'react';
import { TableCell, TableRow } from '@material-ui/core';
import { Link } from 'react-router-dom';

import Organization from 'entities/organization/model';

const styles = {
  nameLink: {
    minWidth: 160,
    display: 'block',
    lineHeight: '32px',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
};

const OrganizationListTableRow = ({
  organization,
  employeeAffiliationsView,
}: {
  organization: Organization;
  employeeAffiliationsView: boolean;
}): JSX.Element => (
  <TableRow>
    <TableCell>
      <Link to={`/organizations/${organization.id}`} className="hoverable" style={styles.nameLink}>
        {organization.name}
      </Link>
    </TableCell>
    <TableCell>
      {organization?.locationObject?.city || 'N/A'}
      {organization?.locationObject?.stateCode
        ? `, ${organization.locationObject.stateCode}`
        : 'N/A'}
    </TableCell>
    <TableCell>{organization?.locationObject?.country || 'N/A'}</TableCell>
    {employeeAffiliationsView && <TableCell>{organization.affiliationsCount || 0}</TableCell>}
  </TableRow>
);

export default OrganizationListTableRow;
